import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';

import { Permiso } from './permiso';

import myGlobals = require('../config');

@Injectable()
export class PermisoService {

  private permisoUrl = myGlobals.default.BASE_URL+'/permiso/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todas las empresas
  getPermisos() {
    return this.http.get(this.permisoUrl)
               .map((response) => response.json());
  }

  //Obtener una empresa
  getPermiso(codModulo: string): Observable<Permiso>  {
    return this.http.get(this.permisoUrl+codModulo)
               .map((response) => response.json());
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/permiso/permiso.service.ts